import React from 'react';
import { Alert, Form, Input } from "antd";
import { Select } from "../../../shared/OptionWidthControl";
import { usePaymentReasonCodes } from '../../viewmodels/usePaymentReasonCodes';
import { paymentErrorMessage } from '../../utilities/paymentErrors';
export default function ReasonFields({ action, requireNote = false, showOptionalNote = false, maxLength = 1000 }) {
  const { codesFor, error } = usePaymentReasonCodes();
  const form = Form.useFormInstance();
  const selected = Form.useWatch('reason_code', form);
  const codes = codesFor(action);
  const noteRequired = requireNote || codes.find(row => row.code === selected)?.note_required;
  return <>{error && <Alert type="error" message={paymentErrorMessage(error)} />}
    <Form.Item name="reason_code" label="Reason" rules={[{ required: true }]}><Select options={codes.map(row => ({ value: row.code, label: row.label }))} /></Form.Item>
    {(noteRequired || showOptionalNote) && <Form.Item name="note" label={noteRequired ? 'Details' : 'Note (optional)'} rules={noteRequired ? [{ required: true, whitespace: true }] : []}><Input.TextArea rows={3} maxLength={maxLength} /></Form.Item>}
  </>;
}
